<template>
  <div id="top" class="grey lighten-2">
    <v-container>
      <v-layout text-xs-center wrap>
        <v-flex xs12 sm4 pt-4>
          <v-img :src="'/img/header.jpg'"></v-img>
        </v-flex>
        <v-flex xs12 sm8 px-3 class="text-xs-center hidden-sm-and-down">
          <div class="gap-40">&nbsp;</div>  

          <span  v-if="language==='RU'">                    
            <p class="anna-name">Анна Братусь</p>
              <hr>
                <p class="anna-name-soprano mt-3">{{ soprano_RU }}</p>
          </span>

          <span v-if="language==='EN'">                    
            <p class="anna-name">Anna Bratus</p>
              <hr>
                <p class="anna-name-soprano mt-3">{{ soprano_EN }}</p>
          </span>

        </v-flex>          
      </v-layout>
    </v-container>
    <div v-if="language==='RU'" class="bottom-line white--text">{{ bottom_RU }}</div>
    <div v-if="language==='EN'" class="bottom-line white--text">{{ bottom_EN }}</div>    
  </div>
</template>

<script>
    export default {
      name: 'Top',
        data(){
          return {
            language: '',
            soprano_RU: 'Сопрано',
            soprano_EN: 'Soprano',
            bottom_RU: 'Анна Братусь. Сопрано. Лауреат и дипломант Международных конкурсов оперных певцов. Заслуженная артистка Украины',
            bottom_EN: 'Anna Bratus. Soprano. Winner and diplomas of the International Opera Competitions. Awarded the title of "Honored artist of Ukraine"'                        
          }
        },
        mounted(){
          if(localStorage.lang){
            this.language = localStorage.lang
          }
        }
      }
</script>
<style>
    #top {
      position: relative;
      z-index: 0;
    }
    .bottom-line {
      padding:4px;
      position: absolute;
      z-index: 1;
      background-color: #111;
      min-height: 25px;
      width: 100%;
      left: 0;
      bottom: 0;
      text-align:center;
      font-family: 'Open Sans Condensed', sans-serif;
    }
</style>
